import React, {useEffect, useRef, useState} from 'react';
import './style.scss';
import Fade from "@material-ui/core/Fade";
import {isEqual} from "lodash";
import SentRouteContainer from "../../Redux/containers/SentRouteContainer";
import {secondsUntil} from "../../Utils/TimeUtils";

const orderOfStatuses = ["ACCEPTED", "ASSIGNED", "SEARCHING_FOR_DRIVER"];

function sentRoutesComparator(a, b) {
    const secondsUntilAFinishes = secondsUntil(a.real_time_finish_time);
    const secondsUntilBFinishes = secondsUntil(b.real_time_finish_time);

    if ((a.status === "ASSIGNED" && b.status === "ASSIGNED") ||
        (a.status === "ACCEPTED" && b.status === "ACCEPTED") ||
        (a.status === "SEARCHING_FOR_DRIVER" && b.status === "SEARCHING_FOR_DRIVER")) {
        if (secondsUntilAFinishes === secondsUntilBFinishes)
            return 0;

        return secondsUntilAFinishes > secondsUntilBFinishes ? 1 : -1;
    }

    const aStatusPos = orderOfStatuses.indexOf(a.status);
    const bStatusPos = orderOfStatuses.indexOf(b.status);

    return aStatusPos > bStatusPos ? 1 : -1;
}

export default function SentRoutes(props) {
    const [routes, setRoutes] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const timeoutRef = useRef(null);

    const onGroupClick = (e, routeId) => {
        if (props.onGroupClick)
            props.onGroupClick(e, routeId);
    };

    useEffect(() => {
        if (!props.routes)
            return;

        let newRoutes = props.routes ? [...props.routes] : [];
        newRoutes = newRoutes.filter(route => props.users.find(user => user.id === route.messenger_id)?.profiles?.messenger?.isWhileMission)

        if (!isEqual(
            newRoutes.map(route => {
                return {id: route.id, messengerId: route.messenger_id, orderIds: route.route.map(stop => stop.order_id)}
            }),
            routes.map(route => {
                return {id: route.id, messengerId: route.messenger_id, orderIds: route.route.map(stop => stop.order_id)}
            }))) {
            setIsVisible(false);

            if (timeoutRef.current)
                clearTimeout(timeoutRef.current);

            timeoutRef.current = setTimeout(() => {
                setIsVisible(true);
                setRoutes(newRoutes);
                timeoutRef.current = undefined;
            }, 500);
        } else if (routes !== newRoutes) {
            setRoutes(newRoutes);
        }
    }, [props.routes, props.users]);

    const onRoutesListWheel = (e) => {
        const container = e.currentTarget;
        const containerScrollPosition = container.scrollLeft;
        container.scrollTo({
            top: 0,
            left: containerScrollPosition + e.deltaY,
            behaviour: "smooth"
        });
    };

    return (
        <div className="sent-routes-content">
            <div
                className={"sent-routes-title-container" + (routes.length > 0 ? " sent-routes-title-container-visible" : " sent-routes-title-container-hidden")}>
                <div className="sent-routes-title">
                    מסלולים בדרכים
                </div>
            </div>
            <Fade timeout={1000} in={isVisible}>
                <div className="sent-routes-list" onWheel={onRoutesListWheel}>
                    {
                        [...routes].sort(sentRoutesComparator).map(route => {
                            return (
                                <div
                                    className={"sent-route-container"}
                                    key={`sent-route-${route.id}`}>
                                    <SentRouteContainer route={route}
                                                        onGroupClick={(e) => onGroupClick(e, route.id)}/>
                                </div>
                            );
                        })
                    }
                </div>
            </Fade>
        </div>
    );
}